export const defaultDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const displayDateTimeFormat = 'D/M/YYYY, hh:mm A';
export const sidebarDateTimeFormat = 'hh.mm A, DD MMM YY';
export const confidenceLevels = ['Greater than 70', 'Between 50 - 70', 'Less than 50'];
export const defaultAdminRoute = 'admin';
